import {
  blue,
  deepOrange,
  green,
  lightGreen,
  orange,
  lightBlue,
  red,
  blueGrey,
  amber,
  yellow,
} from "@mui/material/colors";
import { PaletteOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    deepOrange: typeof deepOrange;
    red?: typeof red;
    orange?: typeof orange;
    green: typeof green;
    lightGreen: typeof lightGreen;
    blue: typeof blue;
    lightBlue?: typeof lightBlue;
    blueGrey: typeof blueGrey;
    amber: typeof amber;
    yellow: typeof yellow;
  }

  interface PaletteOptions {
    deepOrange?: typeof deepOrange;
    red?: typeof red;
    orange?: typeof orange;
    green?: typeof green;
    lightGreen?: typeof lightGreen;
    blue?: typeof blue;
    lightBlue?: typeof lightBlue;
    blueGrey?: typeof blueGrey;
    amber?: typeof amber;
    yellow?: typeof yellow;
  }
}

export const palette: PaletteOptions = {
  primary: {
    main: "#2196F3",
  },

  deepOrange,
  red,
  orange,
  green,
  lightGreen,
  blue,
  lightBlue,
  blueGrey,
  amber,
  yellow,
};
